import { useEffect, useRef, useState } from "react";
import { ChevronDown, Search } from "lucide-react";

export function SearchSelect({ options, value, onChange, placeholder = "Seleccionar", testid = "search-select" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const selected = options.find((o) => o.value === value);
  const filtered = options.filter((o) => o.label.toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        data-testid={testid}
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between border border-slate-200 rounded-md px-3 py-2 text-sm bg-white hover:border-slate-300 transition-colors"
      >
        <span className={`truncate ${selected ? "text-slate-900" : "text-slate-400"}`}>{selected ? selected.label : placeholder}</span>
        <ChevronDown className="w-4 h-4 text-slate-400 shrink-0" />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg overflow-hidden" data-testid={`${testid}-panel`}>
          <div className="relative border-b border-slate-100">
            <Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              autoFocus
              data-testid={`${testid}-search`}
              className="w-full pl-8 pr-3 py-2 text-sm focus:outline-none"
              placeholder="Buscar…"
              value={q}
              onChange={(e) => setQ(e.target.value)}
            />
          </div>
          <div className="max-h-52 overflow-y-auto">
            {filtered.map((o) => (
              <button
                key={o.value}
                type="button"
                data-testid={`${testid}-opt-${o.value}`}
                className={`w-full text-left px-3 py-2 text-sm transition-colors hover:bg-slate-50 ${o.value === value ? "bg-sky-50 text-sky-800 font-medium" : "text-slate-700"}`}
                onClick={() => { onChange(o.value); setOpen(false); setQ(""); }}
              >
                {o.label}
              </button>
            ))}
            {filtered.length === 0 && <p className="px-3 py-3 text-xs text-slate-400">Sin resultados</p>}
          </div>
        </div>
      )}
    </div>
  );
}
